import clsx from 'clsx';

const SIZE_TO_STYLE = {
	sm: 'avatar--sm',
	xl: 'avatar--xl',
};

const SIZE_TO_TEXT_STYLE = {
	sm: 'body-semibold-base',
	xl: 'semantic-avatar-xl',
};

const VARIANT_TO_STYLE = {
	user: 'avatar--user',
	company: 'avatar--company',
	neutral: 'avatar--neutral',
};

export const Avatar = ({
	className = '',
	textClassName = '',
	initials,
	size,
	variant,
	...props
}) => {
	return (
		<div
			className={clsx('avatar', SIZE_TO_STYLE[size], VARIANT_TO_STYLE[variant], className)}
			{...props}
			aria-hidden='true'
		>
			<span className={clsx(SIZE_TO_TEXT_STYLE[size], textClassName)}>{initials}</span>
		</div>
	);
};
